import React from 'react';
import { useWallet } from '../contexts/WalletContext';

const WalletButton: React.FC = () => {
  const { connected, publicKey, connect, disconnect } = useWallet();

  const handleConnect = async () => {
    try {
      await connect();
    } catch (error) {
      console.error('Failed to connect wallet:', error);
    }
  };

  const handleDisconnect = () => {
    disconnect();
  };

  const truncateAddress = (address: string) => {
    return `${address.slice(0, 4)}...${address.slice(-4)}`;
  };

  if (connected && publicKey) {
    return (
      <div className="flex items-center gap-3">
        <div className="bg-gray-800/50 px-3 py-2 rounded-lg">
          <span className="text-sm font-mono text-white">
            {truncateAddress(publicKey.toString())}
          </span>
        </div>
        <button
          onClick={handleDisconnect}
          className="btn-ghost btn-sm"
        >
          Disconnect
        </button>
      </div>
    );
  }

  return (
    <button
      onClick={handleConnect}
      className="btn-primary"
    >
      Connect Wallet
    </button>
  );
};

export default WalletButton;